const interpolateString = (template, data) => {
    return template.replace(/{{(.*?)}}/g, (_, key) => {
        const trimmedKey = key.trim();
        const value = data[trimmedKey];
        if (Array.isArray(value)) {
            return value.join(', ');
        }
        else if (value !== undefined && value !== null) {
            return String(value);
        }
        else {
            return '';
        }
    });
};
const interpolateAll = (input, data) => {
    if (typeof input === 'string') {
        return interpolateString(input, data);
    }
    if (Array.isArray(input)) {
        return input.map((item) => interpolateAll(item, data));
    }
    if (input && typeof input === 'object') {
        const result = {};
        for (const key in input) {
            result[key] = interpolateAll(input[key], data);
        }
        return result;
    }
    // Return non-string primitive as-is
    return input;
};
export { interpolateAll as interpolate };
